<div class="text-align-center">
  <h3 class="t-5@r color-void mb-4">Are You Sure?</h3>

  <div class="t-8@r color-ash mb-6">Photos that are deleted will need to be reviewed again before being approved.</div>

  <div class="grid">
    <button class="g-col-6" sbButton [size]="'big'" [stretchable]="true" [variant]="'fill-red'" (click)="confirm()">
      Delete
    </button>
    <button class="g-col-6" sbButton [size]="'big'" [stretchable]="true" [variant]="'ghost-cloud'" (click)="close()">
      Cancel
    </button>
  </div>
</div>
